export default __webpack_public_path__ + "static/media/Patient-Journey.6ba19951.png";